import { render, staticRenderFns } from "./facebookPages.vue?vue&type=template&id=e6a987ac&scoped=true"
import script from "./facebookPages.vue?vue&type=script&lang=js"
export * from "./facebookPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a987ac",
  null
  
)

export default component.exports